import { render, staticRenderFns } from "./welfare-header.vue?vue&type=template&id=59c04d62&scoped=true&lang=pug&"
import script from "./welfare-header.vue?vue&type=script&lang=js&"
export * from "./welfare-header.vue?vue&type=script&lang=js&"
import style0 from "./welfare-header.vue?vue&type=style&index=0&id=59c04d62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c04d62",
  null
  
)

export default component.exports